// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".object-simple-page[data-v-7211335e]{margin-top:4rem}.object-simple-page[data-v-7211335e] .newsLatestListing-headline{margin-bottom:0}.side-info[data-v-7211335e]> div:not(:last-child){margin-bottom:3rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
